import Joi from 'joi';
import {
  dataTypes,
  conditionTypeOperators
} from '../components/Rules/constants';

const conditionValueValidator = Joi.when('conditionDataType', {
  is: dataTypes.STRING,
  then: Joi.array().items(
    Joi.string()
      .label('Condition')
      .required()
  )
})
  .when('conditionDataType', {
    is: dataTypes.INTEGER,
    then: Joi.array().items(
      Joi.number()
        .integer()
        .label('Condition')
        .required()
    )
  })
  .when('conditionDataType', {
    is: dataTypes.DOUBLE,
    then: Joi.array().items(
      Joi.number()
        .precision(2)
        .label('Condition')
        .required()
    )
  })
  .when('conditionDataType', {
    is: dataTypes.BIGDECIMAL,
    then: Joi.array().items(
      Joi.number()
        .precision(2)
        .label('Condition')
        .required()
    )
  })
  .when('conditionDataType', {
    is: dataTypes.DATE_TIME,
    then: Joi.array().items(
      Joi.date()
        .label('Condition')
        .required()
    )
  })
  .when('conditionDataType', {
    is: dataTypes.DATE,
    then: Joi.array().items(
      Joi.date()
        .label('Condition')
        .required()
    )
  })
  .when('conditionDataType', {
    is: dataTypes.BOOLEAN,
    then: Joi.array().items(
      Joi.string()
        .valid('true', 'false')
        .label('Condition')
        .required()
        .messages({
          'any.invalid': 'Condition must be Boolean, either true or false'
        })
    )
  });

const conditionLessThanValueValidator = Joi.when('conditionDataType', {
  is: dataTypes.INTEGER,
  then: Joi.array().items(
    Joi.number()
      .integer()
      .positive()
      .label('Condition')
      .required()
  )
})
  .when('conditionDataType', {
    is: dataTypes.DOUBLE,
    then: Joi.array().items(
      Joi.number()
        .precision(2)
        .label('Condition')
        .required()
    )
  })
  .when('conditionDataType', {
    is: dataTypes.BIGDECIMAL,
    then: Joi.array().items(
      Joi.number()
        .precision(2)
        .label('Condition')
        .required()
    )
  })
  .when('conditionDataType', {
    is: dataTypes.DATE_TIME,
    then: Joi.array().items(
      Joi.date()
        .label('Condition')
        .required()
    )
  })
  .when('conditionDataType', {
    is: dataTypes.DATE,
    then: Joi.array().items(
      Joi.date()
        .label('Condition')
        .required()
    )
  });

const minMaxconditionValueValidator = Joi.when('conditionDataType', {
  is: dataTypes.STRING,
  then: Joi.array().items(
    Joi.string()
      .label('Condition')
      .required()
  )
})
  .when('conditionDataType', {
    is: dataTypes.INTEGER,
    then: Joi.array()
      .label('Min and Max')
      .ordered(
        Joi.number()
          .integer()
          .label('Condition')
          .required(),
        Joi.number()
          .integer()
          .greater(Joi.ref('0'))
          .label('Condition')
          .required()
          .messages({ 'number.greater': 'Max must be greater than min' })
      )
      .messages({ 'array.includesRequiredKnowns': 'Min and Max are required' })
  })
  .when('conditionDataType', {
    is: dataTypes.DOUBLE,
    then: Joi.array()
      .label('Min and Max')
      .ordered(
        Joi.number()
          .precision(2)
          .label('Condition')
          .required(),
        Joi.number()
          .precision(2)
          .greater(Joi.ref('0'))
          .label('Condition')
          .required()
          .messages({ 'number.greater': 'Max must be greater than min' })
      )
      .messages({ 'array.includesRequiredKnowns': 'Min and Max are required' })
  })
  .when('conditionDataType', {
    is: dataTypes.DATE,
    then: Joi.array()
      .label('Min and Max')
      .ordered(
        Joi.date()
          .label('Condition')
          .required(),
        Joi.date()
          .label('Condition')
          .greater(Joi.ref('0'))
          .required()
          .messages({ 'date.greater': 'Max must be greater than min' })
      )
      .messages({ 'array.includesRequiredKnowns': 'Min and Max are required' })
  })
  .when('conditionDataType', {
    is: dataTypes.DATE_TIME,
    then: Joi.array()
      .label('Min and Max')
      .ordered(
        Joi.date()
          .label('Condition')
          .required(),
        Joi.date()
          .greater(Joi.ref('0'))
          .label('Condition')
          .required()
          .messages({ 'date.greater': 'Max must be greater than min' })
      )
      .messages({ 'array.includesRequiredKnowns': 'Min and Max are required' })
  });

const queryParamsValidator = Joi.object({
  conditionAttribute: Joi.string()
    .label('Reservation Property')
    .required(),
  condition: Joi.string()
    .label('Operator')
    .required(),

  conditionValue: Joi.when('condition', {
    is: conditionTypeOperators.LESS_THAN,
    then: conditionLessThanValueValidator
  })
    .when('condition', {
      is: conditionTypeOperators.LESS_THAN_OR_EQUALS,
      then: conditionLessThanValueValidator
    })
    .when('condition', {
      is: conditionTypeOperators.GREATER_THAN,
      then: conditionValueValidator
    })
    .when('condition', {
      is: conditionTypeOperators.GREATER_THAN_OR_EQUALS,
      then: conditionValueValidator
    })
    .when('condition', {
      is: conditionTypeOperators.EQUALS,
      then: conditionValueValidator
    })
    .when('condition', {
      is: conditionTypeOperators.DOES_NOT_EQUAL,
      then: conditionValueValidator
    })
    .when('condition', {
      is: conditionTypeOperators.CONTAINS,
      then: conditionValueValidator
    })
    .when('condition', {
      is: conditionTypeOperators.DOES_NOT_CONTAIN,
      then: conditionValueValidator
    })
    .when('condition', {
      is: conditionTypeOperators.MATCH_REG_EX,
      then: conditionValueValidator
    })
    .when('condition', {
      is: conditionTypeOperators.RANGE,
      then: minMaxconditionValueValidator
    })
});

export { queryParamsValidator };
